// extracted by mini-css-extract-plugin
export var cardLayout = "_63-1";
export var paginationContainer = "_63-0";